<div class="management-container">
  <!-- Mat-Tab con selección dinámica -->
  <mat-tab-group
    class="tab-group"
    [selectedIndex]="selectedTabKey - 1"
    (selectedIndexChange)="onTabSelected($event)"
  >
    <mat-tab *ngFor="let tab of tabs" [label]="tab.text | capitalize"></mat-tab>
  </mat-tab-group>

  <router-outlet></router-outlet>
</div>
